import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { GameListItem, GetGamesParams, QueryResult } from '../types';

export function useGames(params?: GetGamesParams): QueryResult<GameListItem[]> {
  const { client } = useDubs();
  const [data, setData] = useState<GameListItem[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const paramKey = JSON.stringify(params ?? {});

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const games = await client.getGames(params);
      setData(games);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client, paramKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
